var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimizeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7045 0.577663C23.7929 -0.166513 24.8727 -0.166513 24.9611 0.577663L25.7019 6.82062C26.6584 14.882 33.0141 21.2377 41.0754 22.1942L47.3184 22.935C48.0626 23.0234 48.0626 24.1032 47.3184 24.1916L41.0754 24.9323C33.0141 25.8888 26.6584 32.2446 25.7019 40.3059L24.9611 46.5488C24.8727 47.2931 23.7929 47.2931 23.7045 46.5488L22.9638 40.3059C22.0072 32.2446 15.6515 25.8888 7.59015 24.9323L1.34719 24.1916C0.603019 24.1032 0.603019 23.0234 1.34719 22.935L7.59015 22.1942C15.6515 21.2377 22.0072 14.882 22.9638 6.82062L23.7045 0.577663Z",
    fill: "url(#paint0_linear_593_32713)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_593_32713",
    x1: 24.3328,
    y1: 0.0195312,
    x2: 24.3328,
    y2: 47.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimizeStar);
export default __webpack_public_path__ + "static/media/OptimizeStar.5f6a628fd23fd7738477d26c16118651.svg";
export { ForwardRef as ReactComponent };